import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "not-found-page" }
const _hoisted_2 = ["innerHTML"]

import { pageKey } from '@drapejs/core';
import { computed, inject } from 'vue';
import useMeta from '@/composables/useMeta';


export default /*#__PURE__*/_defineComponent({
  __name: 'NotFound',
  setup(__props) {

const page = inject(pageKey);
const title = computed(() => page?.value?.fields?.Title || '');
const text = computed(() => page?.value?.fields?.Text || '');

useMeta();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", null, _toDisplayString(_unref(title)), 1),
    _createElementVNode("div", { innerHTML: _unref(text) }, null, 8, _hoisted_2)
  ]))
}
}

})